import { TextCol } from "../../records/models/columns/text-col";
import { Fieldwork } from "./models/fieldwork";

export const FIELDWORK_CEC_COLUMNS: TextCol<Fieldwork>[] =
  [
    new TextCol("caseNumber", false, undefined, undefined, true),
    new TextCol("brand", false, undefined, undefined, true),
    new TextCol("regionName", undefined, 'stellantisRegion'), //stellantis region
    new TextCol("market"),
    new TextCol("channel"),
    new TextCol("dealerName"),
    new TextCol("vin", true),
    new TextCol("modelName"),
    new TextCol("emailDiscardReason"),
    new TextCol("customerPhone"),
    new TextCol("mobileDiscardReason"),
    new TextCol("caseOrigin"),
    new TextCol("caseReason", false, undefined, undefined, true, false),
    new TextCol("categoryLevel1", false, undefined, undefined, true, false),
    new TextCol("categoryLevel2", false, undefined, undefined, true, false),
    new TextCol("categoryLevel3", false, undefined, undefined, true, false),
    new TextCol("categoryLevel4", false, undefined, undefined, true, false),
    new TextCol("categoryLevel5"),
    new TextCol("closeReasonL1", false, undefined, undefined, true, false),
    new TextCol("caseSurveyAcceptance", false, undefined, undefined, true, false),
    new TextCol("caseOpenDate", false, undefined, "dd/MM/yyyy", true, false),
    new TextCol("caseClosedDate", false, undefined, "dd/MM/yyyy", true, false),
    new TextCol("callType", false, undefined, undefined, true, false),
    new TextCol("caseSourceDetail", false, undefined, undefined, true, false),
    new TextCol("caseType", false, undefined, undefined, true, false),
    new TextCol("recordType", false, undefined, undefined, true, false),
    new TextCol("recallCode", false, undefined, undefined, true, false),
    new TextCol("recallDescription", false, undefined, undefined, true, false),
    new TextCol("recallFlag", false, undefined, undefined, true, false),
    new TextCol("takataFlag", false, undefined, undefined, true, false),
    new TextCol("eventDate", undefined, undefined, "dd/MM/YYYY"),
    new TextCol("importedDate", undefined, undefined, "dd/MM/YYYY"),
    new TextCol("dateCleanedStatus", undefined, undefined,undefined,true),
    new TextCol("rejectedReason"),
    new TextCol("discardType"),
    new TextCol("initialInvitationDate", undefined, undefined, "dd/MM/YYYY"), //planned first day
    new TextCol("firstReminderDate", undefined, undefined, "dd/MM/YYYY"),
    new TextCol("receivedSurveyConfirmation"),
    new TextCol("interviewStatus", undefined, "fieldworkInterviewStatus", undefined, true),
    new TextCol("expiredDate", undefined, "fieldworkExpiredDate", "dd/MM/YYYY"),
    new TextCol("interviewdate", undefined, undefined, "dd/MM/YYYY"),
    new TextCol("surveyId", true),
   

  ]

